export { numberField as integerField } from './number';
